import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { withdraw, removeCreative } from 'admin/ducks/project_entries';
import DropdownModalForm from 'common/components/modal_dropdown_form';

const forms = (entry) => [{
  label: "Withdraw this entry",
  formName: 'withdraw_one',
  show: !entry.withdrawn,
  fields: [{
    name: 'comment',
    label: 'Comment',
    type: 'textarea',
  }, {
    name: 'project_admin_note',
    label: 'Project Admin Note',
    type: 'textarea',
  }, {
    name: 'user_admin_note',
    label: 'User Admin Note',
    type: 'textarea',
  }]
}, {
  label: "Withdraw all entries by this creative from project",
  formName: 'withdraw_all',
  show: true,
  fields: [{
    name: 'comment',
    label: 'Comment',
    type: 'textarea',
  }, {
    name: 'project_admin_note',
    label: 'Project Admin Note',
    type: 'textarea',
  }, {
    name: 'user_admin_note',
    label: 'User Admin Note',
    type: 'textarea',
  }]
}, {
  label: "Withdraw all entries and remove creative from project",
  formName: 'withdraw_all_and_remove',
  show: true,
  fields: [{
    name: 'comment',
    label: 'Comment',
    type: 'textarea',
  }, {
    name: 'project_admin_note',
    label: 'Project Admin Note',
    type: 'textarea',
  }, {
    name: 'user_admin_note',
    label: 'User Admin Note',
    type: 'textarea',
  }]
}];

const mapStateToProps = (state, { entry }) => {
  return {
    form: `PROJECT_ENTRY_ACTIONS_FORM_${entry.revisions[0].id}`,
    forms: forms(entry),
    initialValues: {
      comment: "Withdrawn by crowdspring."
    }
  };
}

const mapDispatchToProps = (dispatch, { entry }) => {
  return bindActionCreators({
    submitAction: (formName, values) => {
      const data = {
        ...values,
        project: entry.project,
        entries: formName === "withdraw_one"? entry.id : undefined,
      };

      if (formName === "withdraw_all_and_remove") {
        return removeCreative(entry.author, data);
      }

      return withdraw(entry.author, data);
    }
  }, dispatch);
}

const Formify = reduxForm()(DropdownModalForm);

export default connect(mapStateToProps, mapDispatchToProps)(Formify);



// WEBPACK FOOTER //
// ./admin/containers/project_entries/actions_menu.js